import React from 'react';
import { Box, SkeletonText, VStack, Text, HStack } from '@skin-seoul/design-system';
interface SuitableForItemSkeletonProps {
  titleWidth: string;
  itemCount: number;
}
const SuitableForItemSkeleton = ({
  titleWidth,
  itemCount
}: SuitableForItemSkeletonProps) => <VStack gap={3} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-component="SuitableForItemSkeleton" data-sentry-source-file="SuitableForSection.skeleton.tsx">
    <HStack gap={1} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="SuitableForSection.skeleton.tsx">
      <SkeletonText noOfLines={1} height={{
      base: '18px',
      tablet: '20px'
    }} width={titleWidth} textAlign="center" data-sentry-element="SkeletonText" data-sentry-source-file="SuitableForSection.skeleton.tsx" />
      <Box paddingTop="2px" data-sentry-element="Box" data-sentry-source-file="SuitableForSection.skeleton.tsx">
        <SkeletonText noOfLines={1} height="16px" width="16px" textAlign="center" data-sentry-element="SkeletonText" data-sentry-source-file="SuitableForSection.skeleton.tsx" />
      </Box>
    </HStack>
    <HStack gap={2} alignItems="flex-start" flexWrap="wrap" data-sentry-element="HStack" data-sentry-source-file="SuitableForSection.skeleton.tsx">
      {Array.from({
      length: itemCount
    }).map((_, index) => <Box key={index} backgroundColor="neutral.50" borderRadius={8} paddingX={3} paddingY={2}>
          <SkeletonText noOfLines={1} height={{
        base: '18px',
        tablet: '20px'
      }} width={`${60 + index * 10}px`} textAlign="center" />
        </Box>)}
    </HStack>
  </VStack>;
const SuitableForSectionSkeleton = () => {
  return <Box background="white" position="relative" width="100%" data-sentry-element="Box" data-sentry-component="SuitableForSectionSkeleton" data-sentry-source-file="SuitableForSection.skeleton.tsx">
      <Box position="absolute" bottom={0} left={0} right={0} height="1px" background="neutral.100" pointerEvents="none" data-sentry-element="Box" data-sentry-source-file="SuitableForSection.skeleton.tsx" />

      <VStack alignItems="flex-start" justifyContent="center" paddingX={{
      base: 4,
      tablet: 0
    }} paddingY={5} width="100%" gap={6} data-sentry-element="VStack" data-sentry-source-file="SuitableForSection.skeleton.tsx">
        {/* Title */}
        <Text textStyle={{
        base: 'label.large',
        tablet: 'heading.h6'
      }} fontWeight="medium" color="neutral.800" textAlign="left" whiteSpace="nowrap" letterSpacing={{
        tablet: '-0.4px'
      }} data-sentry-element="Text" data-sentry-source-file="SuitableForSection.skeleton.tsx">
          Suitable for
        </Text>

        {/* Suitable For Items Skeleton */}
        <VStack gap={6} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="SuitableForSection.skeleton.tsx">
          <SuitableForItemSkeleton titleWidth="180px" itemCount={3} data-sentry-element="SuitableForItemSkeleton" data-sentry-source-file="SuitableForSection.skeleton.tsx" />
          <SuitableForItemSkeleton titleWidth="120px" itemCount={2} data-sentry-element="SuitableForItemSkeleton" data-sentry-source-file="SuitableForSection.skeleton.tsx" />
          <SuitableForItemSkeleton titleWidth="80px" itemCount={4} data-sentry-element="SuitableForItemSkeleton" data-sentry-source-file="SuitableForSection.skeleton.tsx" />
        </VStack>
      </VStack>
    </Box>;
};
export default SuitableForSectionSkeleton;